import { render, staticRenderFns } from "./NotificationItemPop.vue?vue&type=template&id=073fecab&"
import script from "./NotificationItemPop.vue?vue&type=script&lang=js&"
export * from "./NotificationItemPop.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItemPop.vue?vue&type=style&index=0&id=073fecab&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports